/*import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useParams } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { startOfToday, endOfToday, subDays } from 'date-fns';

ChartJS.register(CategoryScale, LinearScale, TimeScale, PointElement, LineElement, Title, Tooltip, Legend);

function ChargeDrainPage() {
  const { androidId } = useParams();
  const [chartData, setChartData] = useState(null);
  const [chartDate, setChartDate] = useState(null);
  const [filterWeeks, setFilterWeeks] = useState(0); // 0 = Today, 1/4/8 = weeks
  const [noData, setNoData] = useState(false);

  useEffect(() => {
    fetch(`http://localhost:8080/maiApi/device/${androidId}/charge-history`)
      .then(res => res.json())
      .then(data => {
        if (data.length === 0) return;

        const now = new Date();
        let filteredData = [];

        if (filterWeeks === 0) {
          const todayStr = now.toISOString().split('T')[0];
          filteredData = data.filter(row => {
            const rowDateStr = new Date(row.date_time).toISOString().split('T')[0];
            return rowDateStr === todayStr;
          });
        } else {
          const startDate = subDays(now, filterWeeks * 7);
          filteredData = data.filter(row => {
            const rowDate = new Date(row.date_time);
            return rowDate >= startDate && rowDate <= now;
          });
        }

        if (filteredData.length === 0) return;

        const dataPoints = filteredData.map(row => ({
          x: new Date(row.date_time),
          y: Number(row.percent)
        }));

        let ticks = [];
        if (filterWeeks === 0) {
          const start = new Date(now.toISOString().split('T')[0] + 'T00:00:00');
          for (let i = 0; i < 24; i += 2) {
            const tick = new Date(start);
            tick.setHours(i);
            ticks.push(tick);
          }
        }

        setChartDate(
          filterWeeks === 0
            ? startOfToday().toLocaleDateString()
            : `Past ${filterWeeks} week${filterWeeks > 1 ? 's' : ''}`
        );

        setChartData({
          labels: filterWeeks === 0 ? ticks : filteredData.map(row => new Date(row.date_time)),
          datasets: [{
            label: 'Charge % Over Time',
            data: dataPoints,
            fill: false,
            borderColor: 'blue',
            tension: 0.1
          }]
        });
      })
      .catch(error => {
        console.error("Failed to fetch charge history:", error);
      });
  }, [androidId, filterWeeks]);

  const tickOptions = filterWeeks === 0
    ? {
        source: 'labels',
        autoSkip: false,
        callback: val => {
          const date = new Date(val);
          return date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
          });
        }
      }
    : {
        autoSkip: true,
        maxTicksLimit: 12,
        maxRotation: 45,
        minRotation: 45
      };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 20,
          font: {
            size: 14
          }
        }
      },
      title: {
        display: true,
        text: 'Charge Drain Analysis',
        font: {
          size: 18
        }
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      }
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: filterWeeks === 0 ? 'hour' : 'day',
          displayFormats: {
            hour: 'hh:mm a',
            day: 'MMM dd'
          },
          tooltipFormat: filterWeeks === 0 ? 'hh:mm a' : 'MMM dd',
        },
        min: startOfToday().toISOString(),
        max: endOfToday().toISOString(),
        ticks: tickOptions,
        title: {
          display: true,
          text: 'Time (HH:mm AM/PM)'
        }
      },
      y: {
        title: {
          display: true,
          text: 'Charge (%)'
        },
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10
        }
      }
    }
  };

  if (!chartData) return <div>Loading chart...</div>;

  return (
    <div style={{ width: '80%', margin: 'auto' }}>
      {/* Filter Buttons */
     /* <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px', marginBottom: '15px' }}>
        {[
          { label: 'Today', value: 0 },
          { label: '1 Week', value: 1 },
          { label: '4 Weeks', value: 4 },
          { label: '8 Weeks', value: 8 }
        ].map(({ label, value }) => (
          <button
            key={value}
            onClick={() => setFilterWeeks(value)}
            style={{
              backgroundColor: filterWeeks === value ? 'green' : '#e0f2e9',
              color: filterWeeks === value ? 'white' : 'black',
              padding: '8px 16px',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontWeight: 'bold',
              boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
              transition: 'background-color 0.3s ease',
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {chartDate && (
        <p style={{ textAlign: 'right', fontSize: '16px', marginBottom: '10px' }}>
          <strong>{filterWeeks === 0 ? 'Date' : 'Range'}:</strong> {chartDate}
        </p>
      )}
      <Line data={chartData} options={options} />
    </div>
  );
}
//http://localhost:8080/maiApi/device/528580f95f3a8412/charge-history?weeks=1
export default ChargeDrainPage;
*/


import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import { useParams } from 'react-router-dom';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  TimeScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import 'chartjs-adapter-date-fns';
import { startOfToday, endOfToday, subDays } from 'date-fns';

ChartJS.register(CategoryScale, LinearScale, TimeScale, PointElement, LineElement, Title, Tooltip, Legend);

function ChargeDrainPage() {
  const { androidId } = useParams();
  const [chartData, setChartData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filterWeeks, setFilterWeeks] = useState(1);
  
  const serverUrl = process.env.REACT_APP_API_SERVER_URL;

  useEffect(() => {
    const fetchChartData = async () => {
      setIsLoading(true);
      setError(null);
      setChartData(null);

      try {
        const response = await fetch(`${serverUrl}/maiApi/device/${androidId}/charge-history?weeks=${filterWeeks}`);
        if (!response.ok) {
          throw new Error('Failed to fetch data from the server.');
        }
        const data = await response.json();

        if (data.length === 0) {
          setChartData({ labels: [], datasets: [] });
          return;
        }

        const formattedData = {
          labels: data.map(item => new Date(item.last_updated_time)),
          datasets: [
            {
              label: 'Battery Charge %',
              data: data.map(item => parseFloat(item.percent)),
              borderColor: '#1e40af',
              backgroundColor: 'rgba(30, 64, 175, 0.5)',
              tension: 0.1,
            },
          ],
        };
        setChartData(formattedData);

      } catch (e) {
        setError(e.message);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchChartData();
  }, [androidId, filterWeeks, serverUrl]);


  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: {
        display: true,
        text: `Battery Charge History for: ${androidId}`,
        font: { size: 18 }
      },
      // This is a custom plugin to display a message on the canvas if there's no data
      emptyData: {
        text: 'No charge history data available for the selected period.',
      },
    },
    scales: {
      x: {
        type: 'time',
        time: {
          unit: 'day',
          tooltipFormat: 'PPpp',
          ...(filterWeeks === 0
            ? {
                min: startOfToday().toISOString(),
                max: endOfToday().toISOString(),
              }
            : {}),
        },
        title: {
          display: true,
          text: 'Date & Time'
        }
      },
      y: {
        min: 0,
        max: 100,
        title: {
          display: true,
          text: 'Charge (%)'
        }
      }
    }
  };

  if (isLoading) return <div className="p-8 text-center">Loading chart...</div>;
  if (error) return <div className="p-8 text-center text-red-600">Error: {error}</div>;

  return (
    <div className="p-4 sm:p-8 md:p-10 font-sans">
        <div className="bg-white p-6 rounded-lg shadow border border-border-color">
            {/* Filter Buttons */}
            <div className="flex justify-end gap-2 mb-4">
                {[
                { label: 'Today', value: 0 },
                { label: '1 Week', value: 1 },
                { label: '4 Weeks', value: 4 },
                { label: '8 Weeks', value: 8 }
                ].map(({ label, value }) => (
                <button
                    key={value}
                    onClick={() => setFilterWeeks(value)}
                   
                    className={`px-4 py-2 rounded-md font-semibold shadow-sm transition-colors ${
                        filterWeeks === value 
                        ? 'bg-green-600 text-white' 
                       
                        : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
                    }`}
                >
                    {label}
                </button>
                ))}
            </div>

            {/* The Chart */}
            {chartData && (
                // We add a check here. If there is no data, we show a message.
                chartData.datasets.length > 0 ? (
                    <Line data={chartData} options={options} />
                ) : (
                    <div className="text-center p-10 text-text-light">
                        No charge history data available for the selected period.
                    </div>
                )
            )}
        </div>
    </div>
  );
}

export default ChargeDrainPage;
